<div class="title">Management Events</div>

<!--<app-noitems [typeName]="'timeline events'" [isEmpty]="eventData.length==0 && !isLoading" ></app-noitems>-->
@if (eventData.length === 0 && !isLoading && canReadElasticSearch) {
  <div class="noData" id="NoArea">No Data</div>
}
@if (eventData.length === 0 && !isLoading && !canReadElasticSearch) {
  <div class="noData" id="NoArea">
    No Permissions
  </div>
}

<app-loader [isLoading]="isLoading"></app-loader>

@if (eventData.length > 0 && !isLoading) {
  <div
    class="row"
    id="NetworkTimeline"
    style="height: calc(100% - 3.125rem); padding-left: 0rem; padding-right: 2.5625rem"
    >
    @for (alarm of eventData; track trackByTimestamp(i, alarm); let i = $index) {
      <div>
        <div [ngClass]="{ hidden: !isNewDate(i) }" class="timeline">
          <span class="date">{{ formatDate(alarm['@timestamp']) }}</span>
        </div>
        <div class="timeline item">
          <div class="clock icon-Icon_Alarm"></div>
          <div class="connector"></div>
          {{ formatTime(alarm['@timestamp']) }}&nbsp;
          <!-- MOP event -->
          @if (alarm['eventSeverity'] !== undefined && alarm['eventSource'] === 'MOP') {
            <span
              class="bubble severity{{ alarm.eventSeverity | titlecase }}"
              style="margin-right: 0rem"
            ></span>
          }
          <!-- current vtc online -->
          @if (alarm['eventSeverity'] !== undefined && alarm['eventDescription'] === 'VTC Online') {
            <span
              class="bubble severityInfo"
              style="margin-right: 0rem"
            ></span>
          }
          <!-- current vtc offline -->
          @if (alarm['eventSeverity'] !== undefined && alarm['eventDescription'] === 'VTC Offline') {
            <span
              class="bubble severityError"
              style="margin-right: 0rem"
            ></span>
          }
          <!-- current vtc provision -->
          @if (alarm['eventSeverity'] !== undefined && alarm['eventDescription'] === 'VTC Provisioning') {
            <span
              class="bubble severityInfo"
              style="margin-right: 0rem"
            ></span>
          }
          <!-- legacy vtc online event -->
          @if (alarm['severity'] !== undefined && alarm['event'] === 'VTC Online') {
            <span
              class="bubble severityInfo"
              style="margin-right: 0rem"
            ></span>
          }
          <!-- legacy vtc offline event -->
          @if (alarm['severity'] !== undefined && alarm['event'] === 'VTC Offline') {
            <span
              class="bubble severityError"
              style="margin-right: 0rem"
            ></span>
          }
          @if (alarm['commonName'] !== undefined) {
            <span class="name">
              {{ alarm.componentName }}
            </span>
          }
          @if (alarm['commonName'] === undefined) {
            <span> {{ alarm.componentName }} </span>
          }
          <br />
          @if (alarm['eventDescription'] !== undefined) {
            <div class="details">
              {{ alarm.eventDescription }}
            </div>
          }
          <!--<div *ngIf="alarm['event'] !== undefined" class="details">
          {{ alarm.user }}
        </div>-->
      </div>
    </div>
  }
</div>
}
